module.exports = __webpack_public_path__ + "assets/img/authority-3.db83e30e.svg";